import { DSTextInput } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { IContractProps } from './interface'

const Contract = ({ control, accountKey }: IContractProps) => {
  return (
    <Controller
      key={accountKey}
      name='contract'
      control={control}
      render={({ field: { onChange, value } }) => (
        <DSTextInput
          value={value}
          onChange={e => onChange(e.target.value.slice(0, 20))}
          placeholder='Buscar por contrato'
          label='Contrato'
        />
      )}
    />
  )
}

export default Contract
